

( function($) {

    var eprintit = {};

    eprintit.shortcode_fix = function(){
        var p = $('.shortcode p:empty');
        $.each(p, function(){
            // console.log('p remove');
            $(this).remove();
        });
    };

    eprintit.header = function(){

        var self = this;

        self.fix_with_admin_bar = function(){

            var header = $('.site-header');
            var admin_bar = $('#wpadminbar');

            if ( admin_bar.length > 0 && header.length > 0 ) {
                header.css('top', parseInt( admin_bar.css('height') ) + 'px' );
            }

        };

        // an empty placeholder div behind the fixed header to ensure
        // content never starts on top of the header. the css will try to
        // set the height correctly, but javascript will make sure its always
        // exactly correct
        self.set_placeholder_height = function(){

            var header = $('.site-header');
            var ph = $('.fixed-header-placeholder');

            if ( ph.length > 0 ) {
                if ( header.hasClass('is-fixed') ) {
                    var header_height = header.length > 0 ? parseInt( header.css('height' ) ) : undefined;
                    if ( header_height ) {
                        ph.css('height', header_height + 'px' );
                    }
                } else {
                    ph.css('height', 0 );
                }
            }
        };

        // add a class to the header indicating its scrolled down the page
        // (possibly by only more than 0 pixels), so that we can add a box shadow
        // if needed.
        self.scrolled_class = function(){

            var header = $('.site-header');

            if ( header.length > 0 ) {

                var top = parseInt( $(window).scrollTop() );

                if ( top === 0 ) {
                    header.removeClass('scrolled');
                } else {
                    header.addClass('scrolled');
                }
            }

        };

        self.set_placeholder_height();
        self.fix_with_admin_bar();
        self.scrolled_class();
        $(window).on('resize', function(){
            self.set_placeholder_height();
            self.fix_with_admin_bar();
        });

        $(window).on('scroll', function(){
            self.scrolled_class();
        });
    };

    // Doc Ready
    $(document).ready(function() {
        eprintit.shortcode_fix();
        eprintit.header();
    })

}(jQuery));
